import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LoadingSpinnerService } from '../services/loading-spinner.service';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent implements OnInit {
  loadingStatus: boolean = false;

  constructor(
    private loadingSpinnerService: LoadingSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.loadingSpinnerService.loaderActive.subscribe(value => {
      if (value && !this.loadingStatus) {
        this.loadingStatus = value;
        this.cdr.detectChanges();
      } else if (!value) {
        this.loadingStatus = value;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/loading-spinner/loading-spinner.component.ts